import React, { useState } from 'react'
import {
    FormControl,
    MenuItem,
    Select,
    TextField,
    Grid,
    useMediaQuery,
    InputLabel
} from '@mui/material'
import { makeStyles } from '@mui/styles'

import {
    ChangeRequestType,
    ChangeRequestTypeText,
    TABS,
    UserRole,
    UserRoleText,
    USER_PROP,
} from './constants'
import { APPROVAL_PROP } from './ApprovalsTable/constants'
import userActions from './actions'
import approvalActions from './ApprovalsTable/actions'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: '100%',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    formControls: {
        minWidth: '320px',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    formControlItem: {
        minWidth: '320px',
    },
}))

const FilterBar = () => {
    const classes = useStyles()
    const { search } = useSelector((state) => state.user.table)
    const { search: approvalSearch } = useSelector(
        (state) => state.approvals.table,
    )
    const { selectedTab } = useSelector((state) => state.user)
    const [role, setRole] = useState('ALL')
    const [type, setType] = useState('ALL')
    const { setFilter, setSearch, setPageOffset } = userActions()
    const {
        setFilter: setApprovalFilter,
        setSearch: setApprovalSearch,
        setPageOffset: setApprovalPageOffset,
    } = approvalActions()
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'))

    return (
        <Grid container>
            <Grid
                item
                container
                justify="flex-start"
                alignContent="center"
                xs={12}
                lg={7}
            >
                <TextField
                    className={classes.formControl}
                    size="small"
                    variant="outlined"
                    placeholder="Search"
                    value={
                        selectedTab === TABS.MEMBER_TAB
                            ? search
                            : approvalSearch
                    }
                    onChange={(e) => {
                        if (selectedTab === TABS.MEMBER_TAB) {
                            setPageOffset(0)
                            setSearch(e.target.value)
                        } else {
                            setApprovalPageOffset(0)
                            setApprovalSearch(e.target.value)
                        }
                    }}
                />
            </Grid>
            {matches && <Grid item lg={1} />}
            <Grid
                item
                container
                justify="flex-start"
                alignContent="center"
                xs={8}
                lg={4}
            >
                {selectedTab === TABS.MEMBER_TAB && (
                    <FormControl
                        size="small"
                        variant="outlined"
                        className={classes.formControls}
                    >
                        <InputLabel id="role-select-label" sx={{margin:'-8px'}}>Role</InputLabel>
                        <Select
                            className={classes.formControls}
                            value={role}
                            id="role-select"
                            onChange={(e) => {
                                if (e.target.value !== 'ALL') {
                                    setFilter([
                                        {
                                            col: USER_PROP.ROLE,
                                            op: 'eq',
                                            val: e.target.value,
                                        },
                                    ])
                                } else {
                                    setFilter([])
                                }
                                setPageOffset(0)
                                setRole(e.target.value)
                            }}
                            autoWidth
                        >
                            <MenuItem
                                className={classes.formControlItem}
                                value="ALL"
                                key="ALL"
                            >
                                All
                            </MenuItem>
                            {Object.keys(UserRole).map((x) => {
                                return (
                                    <MenuItem
                                        className={classes.formControlItem}
                                        value={UserRole[x]}
                                        key={x}
                                    >
                                        {UserRoleText[UserRole[x]]}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                )}
                {selectedTab === TABS.APPROVAL_TAB && (
                    <FormControl
                        size="small"
                        variant="outlined"
                        className={classes.formControls}
                    >
                        <Select
                            className={classes.formControls}
                            value={type}
                            onChange={(e) => {
                                if (e.target.value !== 'ALL') {
                                    setApprovalFilter([
                                        {
                                            col: APPROVAL_PROP.TYPE,
                                            op: 'eq',
                                            val: e.target.value,
                                        },
                                    ])
                                } else {
                                    setApprovalFilter([])
                                }
                                setApprovalPageOffset(0)
                                setType(e.target.value)
                            }}
                            autoWidth
                        >
                            <MenuItem
                                className={classes.formControlItem}
                                value="ALL"
                                key="ALL"
                            >
                                All
                            </MenuItem>
                            {Object.keys(ChangeRequestType).map((x) => {
                                return (
                                    <MenuItem
                                        className={classes.formControlItem}
                                        value={ChangeRequestType[x]}
                                        key={x}
                                    >
                                        {ChangeRequestTypeText[x]}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                )}
            </Grid>
        </Grid>
    )
}

export default FilterBar
